// Copied from .claude/skills/brand-guidelines/assets/mantine-theme.ts (brand SoT).
// MantineColorsTuple requires hex literals — var(--token) is not accepted by the
// Mantine API, so the hex values below are a deliberately accepted exception to
// the var(--token) rule (see plan FINDING-6). post-colors.js warns but does not block.
import { createTheme, type MantineColorsTuple } from '@mantine/core';
import tokens from './design-tokens.json';

const cyan: MantineColorsTuple = [
  '#e6ffff',
  '#ccffff',
  '#99ffff',
  '#66ffff',
  '#33ffff',
  tokens.palette['--primary'],
  tokens.palette['--primary-hover'],
  '#009999',
  '#006666',
  '#003333',
];

const violet: MantineColorsTuple = [
  '#f3e6ff',
  '#e0ccff',
  '#c299ff',
  '#a366ff',
  '#8533ff',
  tokens.palette['--accent'],
  tokens.palette['--accent-hover'],
  '#5c1f99',
  '#3d1466',
  '#1f0a33',
];

export const e9lMantineTheme = createTheme({
  primaryColor: 'cyan',
  colors: { cyan, violet },
  fontFamily: 'Geist, system-ui, sans-serif',
  headings: { fontFamily: 'Lexend, system-ui, sans-serif' },
  defaultRadius: 'md',
  other: {
    bg: tokens.palette['--bg'],
    bgCard: tokens.palette['--bg-card'],
    text: tokens.palette['--text'],
    textMuted: tokens.palette['--text-secondary'],
  },
});
